import { formatDate } from "date-fns";
import { IHealthRecord } from "../../types";
import { PrescriptionIcon } from "./prescriptions";
import { CircleChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

function HealthRecordCard({
  createdAt,
  recordId,
  patientName,
  doctorNameOrLabName,
}: IHealthRecord) {
  const navigate = useNavigate();
  return (
    <li
      key={recordId}
      className="flex cursor-pointer items-center justify-between gap-2 rounded-md border p-4"
      onClick={() => navigate(`/health-records/${recordId}`)}
    >
      <div className="flex gap-4">
        <div className="shrink-0">
          <PrescriptionIcon />
        </div>
        <div>
          <h4 className="font-bold">for {patientName}</h4>
          <p className="text-sm sm:text-base">
            Prescription {formatDate(createdAt, "dd MMM yyyy")}
          </p>
          <p className="text-sm sm:text-base">
            Consulted with {doctorNameOrLabName ?? "Unknown"}
          </p>
        </div>
      </div>
      <CircleChevronRight className="text-primary" />
    </li>
  );
}

export default HealthRecordCard;
